import { useQuery } from "@tanstack/react-query";
import { apiGetConfig } from "@api/config";

// Per-instance feature flags, fetched once and cached for the session. Used to hide optional
// surfaces (e.g. the Pollstar admin tab) on instances where a feature is disabled.
export function useConfig() {
  return useQuery({
    queryKey: ["config"],
    queryFn: apiGetConfig,
    staleTime: Infinity,
  });
}
